var Icon = (props) => {
    var src="";
   if (props.name) src="/static/"+props.name+'.svg';
   return (<div>
       <img className="icon" src={src}/>
       <style jsx>{`
             .icon{
                height:45px;
            }
            @media(max-width: 768px){
               
                .icon{
                    height:25px;
              }

            }
           `}</style>
       <div>
       {props.text&&(<div>{props.text}</div>)}
       {props.text2&&(<div>{props.text2}</div>)}
       </div>
       
       </div>)
}
export default Icon